module.exports = __webpack_public_path__ + "img/summary-report1.0373aa53.png";